/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions*/

import React from "react"
import SbEditable from "storyblok-react"

import { blokType } from "../../types"
import { FooterGroupCmp, FooterGroupProps } from "./FooterGroup"

interface FooterGroupWrapperProps {
  blok: FooterGroupProps & blokType
}

const FooterGroup: React.FC<FooterGroupWrapperProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <FooterGroupCmp title={blok.title} items={blok.items} />
  </SbEditable>
)

export default FooterGroup
